module.exports = __webpack_public_path__ + "pe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/pe.svg
// module id = 750
// module chunks = 0